import { ReactNode, useRef } from 'react'

import { useBlockScroll, useEscPress, useStack } from 'ui/hooks'

import { useOutsideClick } from '../../hooks'
import { useDialog } from './context'

import * as SC from './styles'

type Props = {
  isStory?: boolean
  children: ReactNode
}

export const Box = (props: Props) => {
  const { isStory = false, children } = props

  const dialog = useDialog()
  const dialogRef = useRef(null)

  useEscPress(() => dialog.close())
  useStack(dialogRef)
  useOutsideClick(dialogRef, () => dialog.close())
  useBlockScroll(!isStory)

  return (
    <SC.Box $opened={dialog.isOpened} ref={dialogRef}>
      {children}
    </SC.Box>
  )
}
